module.exports = __webpack_public_path__ + "img/privilege3.de585cb4.png";